export enum NotifyTypeEnum {
    Info = 1,
    Success,
    Warning,
    Error,
};